import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import MuiTooltip from '@mui/material/Tooltip';

const useStyles = makeStyles(theme => ({
  medium: {
    backgroundColor: `${theme.palette.text.primary}!important`,
    fontSize: '0.8rem',
    fontWeight: 700,
    color: '#000 !important',
  },
  large: {
    backgroundColor: `${theme.palette.text.primary}!important`,
    fontSize: '1rem',
    fontWeight: 700,
    color: '#000 !important',
  },
  tooltip: {
    backgroundColor: `${theme.palette.text.primary}!important`,
    fontWeight: 700,
    color: '#000 !important',
  },
  arrow: {
    color: `${theme.palette.text.primary}!important`,
  },
}));
const Tooltip = ({ size = 'tooltip', children, classes, ...props }) => {
  const styles = useStyles();

  return (
    <MuiTooltip
      classes={{ ...classes, tooltip: styles[size], arrow: styles.arrow }}
      {...props}
    >
      {children}
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  size: PropTypes.oneOf(['medium', 'large']),
  children: PropTypes.node,
  classes: PropTypes.object,
};

export default Tooltip;
